<template>
  <div :data-app-theme="$store.getters.theme"
    class="wrapper"
    :class="{
      hidden:
        ($store.getters.isFullscreenPortfolio &&
          $store.getters.isShownPortfolio) ||
        // $store.getters.isShownLaunchpad ||
        ($store.getters.isFullscreenGame && $store.getters.isShownGame) ||
        ($store.getters.isFullscreenPhotoEditor &&
          $store.getters.isShownPhotoEditor) ||
        ($store.getters.isFullscreenPhotos && $store.getters.isShownPhotos) ||
        ($store.getters.isFullscreenStickies && $store.getters.isShownStickies),
    }"
  >
    <div class="bar-container">
      <div
        class="icon-bio icon"
        :class="{ loading: $store.state.isLoadingBio }"
        v-on:click="showBio"
      >
        <span
          class="indicator"
          :class="{ active: $store.getters.isShownBio }"
        ></span>
      </div>

      <div alt="Portfolio" class="icon-app icon" v-on:click="showPortfolio">
        <span
          class="indicator"
          :class="{ active: $store.getters.isShownPortfolio }"
        ></span>
      </div>

      <div
        alt="Launchpad"
        class="icon-launchpad icon hidden-small"
        @click="$store.commit('toggleLaunchpad')"
      ></div>

      <div
        alt="Game"
        class="icon-arcade icon hidden-small"
        v-on:click="showGame"
      >
        <span
          class="indicator"
          :class="{ active: $store.getters.isShownGame }"
        ></span>
      </div>

      <div
        alt="Photopea"
        class="icon-photopea icon hidden-small"
        v-on:click="showPhotoEditor"
      >
        <span
          class="indicator"
          :class="{ active: $store.getters.isShownPhotoEditor }"
        ></span>
      </div>

      <div
        alt="Photos"
        class="icon-photo icon hidden-small"
        v-on:click="showPhotos"
      >
        <span
          class="indicator"
          :class="{ active: $store.getters.isShownPhotos }"
        ></span>
      </div>

      <div alt="Mail" class="icon-mail icon" v-on:click="showMail">
        <span
          class="indicator"
          :class="{ active: $store.getters.isShownMail }"
        ></span>
      </div>

      <!-- Github (No Indicator) -->
      <div
        alt="Github"
        aria-label="Github"
        onclick="window.open('https://github.com/jaysmartinez', '_blank')"
        class="icon-github icon"
      ></div>

      <!-- LinkedIn (No Indicator) -->
      <div
        alt="LinkedIn"
        onclick="window.open('https://www.linkedin.com/in/jaysmartinez/', '_blank')"
        class="icon-linkedin icon"
      ></div>

      <!-- Medium (No Indicator) -->
      <div
        alt="Medium"
        onclick="window.open('https://medium.com/@jaysmartinez', '_blank')"
        class="icon-medium icon"
      ></div>

      <div
        alt="Stickies"
        class="icon-stickies icon hidden-small"
        v-on:click="showStickies"
      >
        <span
          class="indicator"
          :class="{ active: $store.getters.isShownStickies }"
        ></span>
      </div>

      <button type="button" aria-label="Open Settings" class="icon-settings icon settings-dock" @click="showSettings"><span class="indicator" :class="{ active: $store.state.isShownSettings }"></span></button>
    </div>
  </div>
</template>

<style scoped>
.settings-dock { border: 0; padding: 0; font: inherit; }
.hidden {
  display: none !important;
}

.bar-container {
  width: auto;
  height: 65px;
  background-color: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  border: 1px solid rgb(255, 255, 255, 0.2);
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  z-index: inherit;
}

.wrapper {
  padding-bottom: 10px;
  display: flex;
  justify-content: center;
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 9999; /* Ensures it's always on top of other elements */
}

.icon {
  width: 45px;
  height: 45px;
  border-radius: 10px;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
  margin-right: 10px;
  /* margin-top: -7px;  */
  background: none;
  position: relative;
}

.icon:hover {
  cursor: pointer;
}

.icon-special {
  margin-top: 3px;
  width: 49px;
  height: 49px;
  border-radius: 10px;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
  margin-right: 10px;
  background: none;
}

.icon-special:hover {
  cursor: pointer;
}

.icon-wip {
  background-image: url("../assets/Icons/WIP.webp");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.icon-wip:hover {
  cursor: not-allowed;
}

.icon-launchpad {
  background-image: url("../assets/Icons/Launchpad.webp");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.icon-app {
  background-image: url("../assets/Icons/AppStore.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.icon-photo {
  background-image: url("../assets/Icons/Photo.webp");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.icon-photopea {
  background-image: url("../assets/Icons/Photopea.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.icon-arcade {
  background-image: url("../assets/Icons/Arcade.webp");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.icon-mail {
  background-image: url("../assets/Icons/Mail.webp");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.icon-stickies {
  background-image: url("../assets/Icons/Notes.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.icon-github {
  background-image: url("../assets/Icons/Github.webp");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.icon-linkedin {
  background-image: url("../assets/iPhone-Icons/Linkedin.webp");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.icon-medium {
  background-image: url("../assets/Icons/Medium.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.icon-bio {
  background-image: url("../assets/Icons/IconBioLight.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.icon-bio.loading {
  animation: dock-bounce 0.85s 3;
}

@keyframes dock-bounce {
  0%, 100% {
    transform: translateY(0);
    animation-timing-function: ease-out;
  }
  45% {
    transform: translateY(-24px);
    animation-timing-function: ease-in;
  }
}

@media (prefers-reduced-motion: reduce) {
  .icon-bio.loading {
    animation: none;
  }
}

.icon-settings {
  background-image: url("../assets/Icons/Settings.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.icon-simulator {
  background-image: url("../assets/Icons/Simulator.webp");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom;
}

@media only screen and (max-width: 600px) {
  .bar-container {
    width: 80vw !important;
    border-radius: 4vw;
    margin-left: 4vw;
    margin-right: 4vw;
    height: 10vw !important;
    padding-top: 2vw;
    padding-bottom: 2vw;
    /* display: flex !important;
    justify-content: center !important;
    align-items: center !important; */
  }
  .icon {
    width: 10vw !important;
    height: 10vw !important;
    margin-left: 1vw !important;
    margin-right: 1vw !important;
    border-radius: 2vw !important;
    transform: translateY(0);
  }
  .icon-special {
    width: 8.5vw !important;
    height: 8.5vw !important;
    margin-left: 1vw !important;
    margin-right: 1vw !important;
    border-radius: 2vw !important;
  }
  .hidden-small,
  .indicator {
    display: none;
  }
}

/* Adjust indicator position */
.indicator {
  position: absolute;
  bottom: -7px; /* Move it further down so it's below the icon */
  left: 50%;
  width: 4px;
  height: 4px;
  background: rgb(0, 0, 0, 0.8);
  border-radius: 50%;
  transform: translateX(-50%);
  opacity: 0; /* Hidden by default */
}

/* Show indicator when active */
.indicator.active {
  opacity: 1;
}

[data-app-theme="dark"] .indicator, .indicator[data-app-theme="dark"] {
    background: rgb(255, 255, 255, 0.5);
  }

[data-app-theme="dark"] .bar-container, .bar-container[data-app-theme="dark"] {
    background-color: rgba(29, 26, 26, 0.2);
  }

[data-app-theme="dark"] .icon-bio, .icon-bio[data-app-theme="dark"] {
    background-image: url("../assets/Icons/IconBioDark.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }

[data-app-theme="dark"] .icon-medium, .icon-medium[data-app-theme="dark"] {
    background-image: url("../assets/Icons/MediumDark.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }

[data-app-theme="dark"] .icon-github, .icon-github[data-app-theme="dark"] {
    background-image: url("../assets/Icons/GithubDark.webp");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
</style>

<script>
export default {
  props: {
    shownProp: Boolean,
  },
  data() {
    return {
      showHello: this.shownProp,
    };
  },
  methods: {
    showSettings() { this.$store.commit("toggleShownSettings", true); this.$store.commit("changeActiveWindow", "Settings"); this.$nextTick(() => this.$store.commit("zIndexIncrement", "settings")); },
    toggleShow() {
      this.showHello = false;
    },
    showPortfolio() {
      // this.$store.commit(
      //   "toggleShownPortfolio",
      //   !this.$store.getters.isShownPortfolio
      // );
      this.$store.commit("changeActiveWindow", "Portfolio");
      this.$store.commit("toggleShownPortfolio", true);
      setTimeout(() => {
        this.$store.commit("zIndexIncrement", "portfolio");
      }, 1);
    },
    showGame() {
      this.$store.commit("changeActiveWindow", "Game");
      this.$store.commit("toggleShownGame", true);
      setTimeout(() => {
        this.$store.commit("zIndexIncrement", "game");
      }, 1);
    },
    showPhotoEditor() {
      this.$store.commit("changeActiveWindow", "Photopea");
      this.$store.commit("toggleShownPhotoEditor", true);
      setTimeout(() => {
        this.$store.commit("zIndexIncrement", "photoeditor");
      }, 1);
    },
    showPhotos() {
      this.$store.commit("changeActiveWindow", "Photos");
      this.$store.commit("toggleShownPhotos", true);
      setTimeout(() => {
        this.$store.commit("zIndexIncrement", "photos");
      }, 1);
    },
    showStickies() {
      this.$store.commit("changeActiveWindow", "Stickies");
      this.$store.commit("toggleShownStickies", true);
      setTimeout(() => {
        this.$store.commit("zIndexIncrement", "stickies");
      }, 1);
    },
    showMail() {
      this.$store.commit("changeActiveWindow", "Mail");
      this.$store.commit("toggleShownMail", true);
      setTimeout(() => {
        this.$store.commit("zIndexIncrement", "mail");
      }, 1);
    },
    showBio() {
      // this.$store.commit("toggleShownBio", !this.$store.getters.isShownBio);
      this.$store.commit("changeActiveWindow", "Bio");
      this.$store.commit("toggleShownBio", true);
      setTimeout(() => {
        this.$store.commit("zIndexIncrement", "bio");
      }, 1);
    },
    showSimulator() {
      this.$store.commit("changeActiveWindow", "Simulator");
      this.$store.commit("toggleShownSimulator", true);
      setTimeout(() => {
        this.$store.commit("zIndexIncrement", "simulator");
      }, 1);
    },
  },
  mounted: function () {},
};
</script>
